import { authSelectors, authSlice } from 'features/auth/authSlice';
import { errorHandlingSlice, errorHandlingSliceSelectors } from 'features/errorHandling/errorHandlingSlice';
import { filtersWorkOrderSelectors } from 'features/filtersWorkOrder/filtersWorkOrderSlice';
import { collapseStateSelectors, collapseStateSlice } from 'features/memoizedValues/collapseStateSlice';
import { memoizedValuesSelectors, memoizedValuesSlice } from 'features/memoizedValues/memoizedValuesSlice';
import { notificationsSelectors, notificationsSlice } from 'features/notifications/notificationsSlice';
import type { IRequestState } from 'features/request/requestSlice';
import { requestSelectors, requestSlice } from 'features/request/requestSlice';
import type { SelectionState } from 'features/selection/selectionSlice';
import { composeSelectors } from 'utils/composeSelectors';
import { createMultiStateSelector } from 'utils/createMultiStateSelector';
import { createSliceSelector } from 'utils/createSelectorsByName';

import type { Selector } from '@reduxjs/toolkit';

import type { RootState } from './store';

export const { isAuthenticatedSelector, getAuthHeader, getUserInfo, getUserProfile } = composeSelectors(
    createSliceSelector<RootState>(authSlice.name),
    authSelectors,
);

export const { getRequest } = composeSelectors(createSliceSelector<RootState>(requestSlice.name), requestSelectors);

export const createGetRequest = createMultiStateSelector<IRequestState>(
    createSliceSelector<RootState>('requests') as Selector<unknown, Record<string, IRequestState>>,
);

export const createGetSelection = createMultiStateSelector<SelectionState>(
    createSliceSelector<RootState>('selections') as Selector<unknown, Record<string, SelectionState>>,
);

export const createGetPin = createMultiStateSelector<SelectionState>(
    createSliceSelector<RootState>('pins') as Selector<unknown, Record<string, SelectionState>>,
);

export const createGetFiltersWorkOrder = composeSelectors(
    createSliceSelector<RootState>('filtersWorkOrder'),
    filtersWorkOrderSelectors,
);

export const { getItems: getNotificationItems } = composeSelectors(
    createSliceSelector<RootState>(notificationsSlice.name),
    notificationsSelectors,
);

export const { getErrorHandlingState } = composeSelectors(
    createSliceSelector<RootState>(errorHandlingSlice.name),
    errorHandlingSliceSelectors,
);

export const { getMemoizedValues } = composeSelectors(
    createSliceSelector<RootState>(memoizedValuesSlice.name),
    memoizedValuesSelectors,
);

export const { getCollapseStateValues } = composeSelectors(
    createSliceSelector<RootState>(collapseStateSlice.name),
    collapseStateSelectors,
);
